// @boty/database - Telegram Integration Query Utilities (Story 15.1)

import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database, TelegramIntegrationInsert } from '../types';

type DbClient = SupabaseClient<Database>;

// ============================================================================
// TELEGRAM INTEGRATION QUERIES
// ============================================================================

/**
 * Get Telegram integration for a specific bot.
 * Returns null if no integration exists (uses maybeSingle).
 */
export async function getTelegramIntegration(
  client: DbClient,
  botId: string,
) {
  const { data, error } = await client
    .from('telegram_integrations')
    .select('*')
    .eq('bot_id', botId)
    .maybeSingle();

  if (error) throw error;
  return data;
}

/**
 * Create or update a Telegram integration for a bot.
 * Uses upsert on bot_id (unique constraint) to handle reconnection.
 */
export async function upsertTelegramIntegration(
  client: DbClient,
  data: TelegramIntegrationInsert,
) {
  const { data: result, error } = await client
    .from('telegram_integrations')
    .upsert(data, { onConflict: 'bot_id' })
    .select()
    .single();

  if (error) throw error;
  return result;
}

/**
 * Delete Telegram integration for a bot.
 */
export async function deleteTelegramIntegration(
  client: DbClient,
  botId: string,
) {
  const { error } = await client
    .from('telegram_integrations')
    .delete()
    .eq('bot_id', botId);

  if (error) throw error;
}
